// Campus photo for /colleges/state-university-of-new-york-at-binghamton: CC BY-SA 2.0, by Claire H. from New York City, USA, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ASUNY_Binghamton_quad.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/state-university-of-new-york-at-binghamton/; credited under the photo.
const photo = {
    "slug": "state-university-of-new-york-at-binghamton",
    "alt": "The library tower rising behind a green lawn on the Binghamton University campus under a blue sky",
    "src": "/colleges/state-university-of-new-york-at-binghamton/campus-1600.webp",
    "srcSmall": "/colleges/state-university-of-new-york-at-binghamton/campus-800.webp",
    "srcMid": "/colleges/state-university-of-new-york-at-binghamton/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/state-university-of-new-york-at-binghamton/og.jpg",
    "title": "SUNY Binghamton quad",
    "author": "Claire H. from New York City, USA",
    "license": "CC BY-SA 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ASUNY_Binghamton_quad.jpg",
    "read": "2026-10-01"
};

export default photo;
